import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const getCreditHistoryApi = (data, callback, errorCallBack) => {

  return async (dispatch) => {

    formDataCommonFunction(data, apiConstants.USER.GET_CREDIT_HISTORY)
      .then((response) => {
        callback && callback(response)

      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}